var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"buttonsContainer"},_vm._l((_vm.block.buttons),function(button){return _c('div',{key:button.id,class:`size-${_vm.block.size ?? 'auto'}`},[_c('ExternalButton',{attrs:{"block":_vm.block,"button":button}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }